module.exports = __webpack_public_path__ + "static/img/client-6.820352bb.png";